import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import ISearchField from '../../components/text-component/search-field/i-searchfield.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE } from '../common/constants';
import { isEmptyArray } from '../common/util.services';
import './supplier-list.component.scss';
import { deleteSupplier, getSupplier } from './supplier.services';

const SupplierList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [role, setRole] = useState<String>('USER');
  const [searchText, setSearchText] = useState(EMPTY_STRING);
  const [supplierData, setSupplierData] = useState(rows);
  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', filterable: false, sortable: false, editable: false, width: 250 },
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 70 },
    { field: 'primaryContact', headerName: 'Primary Contact', filterable: false, sortable: false, editable: false, width: 180 },
    { field: 'primaryNumber', headerName: 'Primary Number', filterable: false, sortable: false, editable: false, width: 130 },
    { field: 'gstin', headerName: 'GSTIN', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'city', headerName: 'City', filterable: false, sortable: false, editable: false, width: 120 },
    { field: 'products', headerName: 'Products', filterable: false, sortable: false, editable: false, width: 150 },
    { field: 'address', headerName: 'Address', filterable: false, sortable: false, editable: false, width: 220}
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (appContext.userData) {
      setRole(appContext.userData.role);
    }
    if (isEmptyArray(rows)) {
      getSupplier(searchText, page, pageSize, appContext,
        (response: any) => {
          setSupplierData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, [searchText, page, pageSize]);

  const handleEditAction = (row: any) => {
    navigate(EMPTY_STRING + row.rowId);
  };

  const handleDeleteAction = (row: any) => {
    deleteSupplier(row.rowId, appContext,
      (response: any) => {
        setSupplierData(supplierData.filter((r) => r.rowId !== row.rowId));
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });

  }

  const addMasterData = () => {
    navigate('new');
  }

  const search = (e: any) => {
    setSearchText(e);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <ISearchField onActionEvent={search} />
      <IGridComponent title={''} rows={supplierData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={'ADMIN' === role || 'LFHADMIN' === role || 'USER' === role || 'AMZUSER' === role || 'AMZUSEREDIT' === role} 
        handleDeleteAction={handleDeleteAction} handleEditAction={handleEditAction} showApproveAction={false} 
        showAddBtn={'ADMIN' === role || 'LFHADMIN' === role || 'USER' === role || 'AMZUSER' === role || 'AMZUSEREDIT' === role}
        getRowId={(row: any) => row.rowId} addRow={addMasterData} maxHeight={450}/>
    </>
  }

  return <>
    <TitlePanel title='Suppliers' panelBody={getMainPanel()} />
  </>
}

export default SupplierList;